import { render, staticRenderFns } from "./SelectCommunityDevice.vue?vue&type=template&id=72b20891&scoped=true&"
import script from "./SelectCommunityDevice.vue?vue&type=script&lang=js&"
export * from "./SelectCommunityDevice.vue?vue&type=script&lang=js&"
import style0 from "./SelectCommunityDevice.vue?vue&type=style&index=0&id=72b20891&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b20891",
  null
  
)

export default component.exports